import React from "react";

const Footer = () => {
  return (
    <footer className="bg-light text-center py-3">
      <p>&copy; 2025 LeaseProtect App By leBackyard</p>
    </footer>
  );
};

export default Footer;
